import { createFileRoute } from '@tanstack/react-router'
import { TraxcnCompanyDetail } from '@/features/traxcn-company-detail'

export const Route = createFileRoute(
  '/_authenticated/traxcn-companies/$id/'
)({
  component: TraxcnCompanyDetail,
})
